export const SAVEPROFILEPIC = "SAVEPROFILEPIC";
export const SAVEPROFILEPIC_ERROR = "SAVEPROFILEPIC_ERROR";
export const SAVEPROFILEPIC_HIDE_ERROR = "SAVEPROFILEPIC_HIDE_ERROR";
export const SAVEPROFILEPIC_START_LOADER = "SAVEPROFILEPIC_START_LOADER";
export const SAVEPROFILEPIC_STOP_LOADER = "SAVEPROFILEPIC_STOP_LOADER";
